import ModalForm from "./Form";
import ModalFormView from "./FormView";
import ModalFormEditVoucher from "./FormEditVoucher";
import { API_VOUCHER, DATATABLE_EXPORT } from "../../../../Config/ApiUrl";

export const Schema = {
	components: { ModalForm, ModalFormView, ModalFormEditVoucher },

	data() {
		return {
			DATATABLE_EXPORT,
			isClaimModalActive: false,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			tableId: "voucher-request-table",
			rowData: {},
			formId: "voucher-request-form",
			tableColumns: [
				{},
				{
					title: this.$t('table_voucher_lead_to'),
					type: "text",
					key: "to_lead_name",
					// modifier: (value) => {
					// 	return value?.to_lead_name;
					// },
				},
				{
					title: this.$t('table_voucher_academic_calendar'),
					type: "text",
					key: "academic_calendar_name",
					// modifier: (value) => {
					// 	return value?.academic_calendar_name;
					// },
				},
				{
					title: this.$t('table_voucher_school_term'),
					type: "text",
					key: "school_term",
					modifier: (value) => {
						return value ? 'Term ' + value : '';
					},
				},
				// {
				// 	title: this.$t('table_voucher_product'),
				// 	type: "text",
				// 	key: "product_name",
				// },
				// {
				// 	title: this.$t('table_voucher_package'),
				// 	type: "text",
				// 	key: "package_name",
				// },
				{
					title: this.$t('table_voucher_category'),
					type: "text",
					key: "voucher_category_description",
				},
				{
					title: this.$t('table_voucher_type'),
					type: "custom-html",
					key: "voucher_type",
					isVisible: true,
					modifier: (value) => {
						let label = value;
						let ClassName = "primary";
						if (label.includes('GIFT')) ClassName = `success`;
						else if (label.includes('REWARD')) ClassName = `info`;
						// else label = 'Student';
						return `<span class="badge badge-sm badge-pill badge-${ClassName}">${label.replace('_', ' ')}</span>`;
					},
				},
				{
					title: this.$t('table_voucher_code'),
					type: "text",
					key: "voucher_code",
				},
				{
					title: this.$t('table_voucher_due_date'),
					type: "custom-html",
					key: "due_date",
					modifier: (value) => {
						if (!value) return "-";
						const date = new Date(value);
						if (isNaN(date)) return value;
						const options = { month: "short", day: "2-digit", year: "numeric" };
						return date.toLocaleDateString("en-US", options);
					},
				},
				// {
				// 	title: this.$t('table_voucher_created_by'),
				// 	type: "text",
				// 	key: "created_by",
				// 	modifier: (value) => {
				// 		return value ?? false;
				// 	},
				// },
				{
					title: this.$t('table_voucher_approval_status'),
					type: "custom-html",
					key: "approval_status",
					isVisible: true,
					modifier: (value) => {
						if (this.$can("view_tab_approval_voucher")) {
							let ClassName = "danger";
							if (value.includes('APPROVED')) ClassName = `success`;
							else if (value.includes('PENDING')) ClassName = `warning`;
							else if (value.includes('EXPIRED')) ClassName = `danger`;
							return `<span class="badge badge-sm badge-pill badge-${ClassName}">${value.replace('_', ' ')}</span>`;
						} else {
							return false;
						}
					},
				},
				{
					title: this.$t('table_voucher_claim_status'),
					type: 'button',
					key: "claim_status",
					className: 'btn btn-info',
					isVisible: true,
					modifier: (value, row) => {
						if (this.isExpired(rowData)) return `<span class="badge badge-sm badge-pill badge-danger">EXPIRED</span>`;
						if (this.$can("view_tab_claim_voucher")) {
							// console.log(value, row);
							return value ? 'Claim' : false;
						} else {
							return false;
						}
					},
				},
				{
					title: this.$t('table_voucher_gift_status'),
					type: 'button',
					key: "gift_status",
					className: 'btn btn-info',
					isVisible: true,
					modifier: (value, row) => {
						if (this.isExpired(rowData)) return `<span class="badge badge-sm badge-pill badge-danger">EXPIRED</span>`;
						if (this.$can("view_tab_claim_voucher")) {
							// console.log(value, row);
							return value ? 'Send' : false;
						} else {
							return false;
						}
					},
				},
			],
			tableActions: [
				{
					title: this.$t("view"),
					icon: "eye",
					type: "none",
					className: 'btn btn-info',
					component: "app-add-modal",
					modalId: "voucher-request-form",
					uniqueKey: (rowData) => rowData.id,
				},
				// {
				// 	title: this.$t("delete"),
				// 	icon: "trash",
				// 	type: "none",
				// 	className: 'btn btn-danger',
				// 	component: "app-confirmation-modal",
				// 	modalId: "demo-delete",
				// },
				{
					title: this.$t("approve_voucher"),
					icon: "check",
					type: "none",
					className: "btn btn-success",
					component: "app-confirmation-modal",
					modalId: "voucher-request-approve",
					key: "voucher-approval",
					modifier: () => this.$can("view_tab_approval_voucher"),
					uniqueKey: (rowData) => rowData.id,
					disabled: (rowData) => this.isExpired(rowData),
				},
				{
					title: this.$t("reject_voucher"),
					icon: "slash",
					type: "none",
					className: "btn btn-warning",
					component: "app-confirmation-modal",
					modalId: "voucher-request-reject",
					key: "voucher-approval",
					modifier: () => this.$can("view_tab_approval_voucher"),
					uniqueKey: (rowData) => rowData.id,
					disabled: (rowData) => this.isExpired(rowData),
				},
				// {
				// 	title: 'Send',
				// 	type: "button",
				// 	className: "btn btn-info",
				// 	component: "app-confirmation-modal",
				// 	modalId: "voucher-request-approve",
				// 	key: "voucher-send-gift",
				// 	modifier: () => this.$can("view_tab_claim_voucher"),
				// },
			],
			ENDPOINT: API_VOUCHER,
			actionObj: {
				title: this.$t("action"),
				type: "action",
				key: "actions",
			},
			options: {
				name: "Voucher",
				url: API_VOUCHER,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [],
				filters: [],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => { })
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
		formattedIDR(value) {
			// Format the value as IDR
			return new Intl.NumberFormat("id-ID", {
				style: "currency",
				currency: "IDR",
				minimumFractionDigits: 0,
			}).format(value);
		},
        isExpired(rowData) {
            return rowData.approval_status.includes('EXPIRED');
        }
    },
};
